import React from 'react' 

import classes from './Logo.module.css'



const Logo = props => {
    return (
        <div className={classes['Logo']}>
            <h2>Food</h2>
        </div>
    )
}

export default Logo